import React from "react";
import { modalReducer, ModalActionType } from "../reducers/modalReducer.js";
import { focusReducer, FocusActionType } from "../reducers/focusReducer.js";
import Modals from "../components/Modals.js";
const defaultModalState = {
    stack: [],
    stopClickOnOutside: false,
};
const ModalContext = React.createContext({
    data: defaultModalState,
    spawnModal: (_content) => { },
    despawnModal: () => { },
    despawnAllModals: () => { },
    opts: undefined,
});
const ModalHelperProvider = ({ children, opts }) => {
    const [modalState, modalDispatcher] = React.useReducer(modalReducer, defaultModalState);
    const [, focusDispatcher] = React.useReducer(focusReducer, []);
    function spawnModal(content, fullscreen) {
        focusDispatcher({
            type: FocusActionType.addFocusElement,
            element: document.activeElement,
        });
        modalDispatcher({
            type: ModalActionType.spawnModal,
            content,
            fullscreen,
        });
    }
    function despawnModal() {
        modalDispatcher({ type: ModalActionType.despawnModal });
        focusDispatcher({ type: FocusActionType.removeFocusElement });
    }
    function despawnAllModals() {
        modalDispatcher({ type: ModalActionType.despawnAllModals });
        focusDispatcher({ type: FocusActionType.focusFirstElement });
    }
    return (React.createElement(ModalContext.Provider, { value: {
            data: modalState,
            spawnModal,
            despawnModal,
            despawnAllModals,
            opts,
        } }, children));
};
const ModalProvider = ({ children, opts, }) => {
    return (React.createElement(ModalHelperProvider, { opts: opts },
        React.createElement(Modals, null),
        children));
};
export { ModalContext, ModalProvider };
//# sourceMappingURL=Modal.js.map